function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as c } from "react/jsx-runtime";
import { useTheme as s } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: r , size: a = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = m(), l = r !== null && r !== void 0 ? r : h ? o.colors.inverse : o.colors.neutralHigh, { skinName: t  } = s();
    return t.match(/^o2/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ c("path", {
            fill: l,
            d: "M17.912 2H4v20h16V4.144C20 2.964 19.06 2 17.912 2zM5.393 9.145h13.218v4.608H5.393V9.145zm13.214-5.001v3.927H5.393V3.43h12.52c.382 0 .694.32.694.713zM5.393 20.574v-5.751h13.218v5.75H5.393zm4.345-15H6.956a.544.544 0 01-.52-.534c0-.283.244-.535.52-.535h2.782c.277 0 .521.252.521.535a.544.544 0 01-.52.535zm0 4.64H6.956a.544.544 0 00-.52.536c0 .283.244.535.52.535h2.782a.544.544 0 00.521-.535.54.54 0 00-.52-.535zM6.956 15.93h2.782c.28 0 .521.252.521.535a.544.544 0 01-.52.535H6.955a.544.544 0 01-.52-.535c0-.283.244-.535.52-.535z"
        })
    })) : /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ c("path", {
            fill: l,
            d: "M21.85 9.768l-.006 4.46c0 .314-.101.602-.266.84.168.241.271.532.271.849l-.005 4.46a1.46 1.46 0 01-1.451 1.464H3.61a1.46 1.46 0 01-1.448-1.465l.006-4.46c0-.313.098-.601.263-.84a1.48 1.48 0 01-.272-.848l.006-4.46c0-.313.098-.602.263-.84a1.48 1.48 0 01-.272-.849l.006-4.459c0-.807.65-1.465 1.448-1.465h16.782A1.46 1.46 0 0121.84 3.62l-.006 4.46c0 .313-.098.602-.266.84.177.24.28.532.28.848zM3.397 3.62l-.005 4.46c0 .12.098.223.221.223h16.782c.123 0 .22-.1.22-.224l.006-4.459a.22.22 0 00-.22-.221H3.616a.22.22 0 00-.219.221zM18.21 7.455c-1.023 0-1.63-.617-1.63-1.65 0-1.034.61-1.65 1.63-1.65s1.63.616 1.63 1.65c0 1.03-.608 1.65-1.63 1.65zm-.65-1.65c0 .484.17.658.65.658.479 0 .65-.174.65-.658 0-.488-.171-.658-.65-.658-.48 0-.65.173-.65.658zm.63 4.546c1.023 0 1.63.616 1.63 1.65 0 1.034-.61 1.65-1.63 1.65s-1.63-.616-1.63-1.65c0-1.03.61-1.65 1.63-1.65zm.65 1.65c0-.485-.17-.658-.65-.658-.479 0-.65.173-.65.658.003.487.171.658.65.658.48 0 .65-.174.65-.658zm-.65 4.552c1.023 0 1.63.616 1.63 1.65 0 1.033-.61 1.65-1.63 1.65s-1.63-.617-1.63-1.65c0-1.034.61-1.65 1.63-1.65zm0 2.308c.48 0 .65-.174.65-.658 0-.485-.17-.659-.65-.659-.479 0-.65.174-.65.659.003.484.171.658.65.658zm2.429-2.944a.22.22 0 00-.222-.221H3.617c-.12 0-.219.1-.219.224l-.005 4.46a.22.22 0 00.221.22h16.782a.226.226 0 00.218-.224l.006-4.46zm-.227-1.468c.123 0 .221-.1.221-.224l.006-4.46a.22.22 0 00-.222-.22H3.617a.22.22 0 00-.219.22l-.005 4.46a.22.22 0 00.218.224h16.782zM4.289 5.802c0 .345.275.622.614.622h5.683a.617.617 0 00.614-.622.617.617 0 00-.614-.622H4.903a.617.617 0 00-.614.622zm6.297 5.58c.339 0 .614.277.614.622a.619.619 0 01-.614.622H4.903a.617.617 0 01-.614-.622c0-.345.275-.622.614-.622h5.683zm.614 6.86a.617.617 0 00-.614-.622H4.903a.617.617 0 00-.614.622c0 .344.275.622.614.622h5.683a.617.617 0 00.614-.622z"
        })
    }));
}, f = i;
export { f as default };
